import { keyframes } from 'styled-components'

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

const bounceIn = keyframes`
0% {
    opacity: 0;
    transform: scale(.3);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
  70% { transform: scale(.9); }
  100% { transform: scale(1); }
`

export interface AnimationsInterface {
  fadeIn: any
  bounceIn: any
}

export const animations: AnimationsInterface = {
  fadeIn,
  bounceIn,
}



// WEBPACK FOOTER //
// ./src/utils/theme/animations.ts